import authRoutes from '@sopranodesign/pulse-auth';
import metricsRoutes from '@sopranodesign/pulse-metrics';
import complianceRoutes from '@sopranodesign/pulse-compliance';
import faqRoutes from '@sopranodesign/pulse-faqs';
import trainingRoutes from '@sopranodesign/pulse-training';
import fallbackRoutes from '@sopranodesign/pulse-fallback';
import demoRoutes from '@sopranodesign/pulse-demo';
import smalltalkRoutes from '@sopranodesign/pulse-smalltalk';
import convoRoutes from '@sopranodesign/pulse-convo';
import botRoutes from '@sopranodesign/pulse-bot';
import broadcastRoutes from '@sopranodesign/pulse-broadcast';
import templateRoutes from '@sopranodesign/pulse-templates';
import blockRoutes from '@sopranodesign/pulse-block';
import clientRoutes from '@sopranodesign/pulse-clients';
import chatRoutes from '@sopranodesign/pulse-chat';
import feedbackRoutes from '@sopranodesign/pulse-feedback';
import integrationsRoutes from '@sopranodesign/pulse-integrations';
import nlpRoutes from '@sopranodesign/pulse-nlp';
import paymentRoutes from '@sopranodesign/pulse-payments';
import channelRoutes from '@sopranodesign/pulse-channels';
import docsRoutes from '@sopranodesign/pulse-docs';
import facebookRoutes from '@sopranodesign/pulse-facebook';
import generativeAiRoutes from '@sopranodesign/pulse-genai';
import workplaceRoutes from '@sopranodesign/pulse-facebook-workplace';
import teamRoutes from '@sopranodesign/pulse-teams';
import importRoutes from '@sopranodesign/pulse-import';
import composerRoutes from '@sopranodesign/pulse-custom-composers';
import ticketRoutes from '@sopranodesign/pulse-tickets';
import groupRoutes from '@sopranodesign/pulse-groups';
import logRoutes from '@sopranodesign/pulse-logs';
import telegramRoutes from '@sopranodesign/pulse-telegram';
import builderRoutes from '@sopranodesign/pulse-builder';
import instagramRoutes from '@sopranodesign/pulse-instagram';
import linkRoutes from '@sopranodesign/pulse-links';
import fileRoutes from '@sopranodesign/pulse-files';
import alexaRoutes from '@sopranodesign/pulse-alexa';
import voipRoutes from '@sopranodesign/pulse-voip';
import whatsAppRoutes from '@sopranodesign/pulse-whatsapp';
import smsRoutes from '@sopranodesign/pulse-sms';
import rcsRoutes from '@sopranodesign/pulse-rcs';
import viberRoutes from '@sopranodesign/pulse-viber';
import voiceRoutes from '@sopranodesign/pulse-voice';
import voiceCallRoutes from '@sopranodesign/pulse-voice-call';

import mcpRoutes from '../../../plugins/pulse-mcp/src/routes';

const pluginRoutes = [
  ...metricsRoutes,
  ...authRoutes,
  ...complianceRoutes,
  ...faqRoutes,
  ...trainingRoutes,
  ...fallbackRoutes,
  ...demoRoutes,
  ...smalltalkRoutes,
  ...convoRoutes,
  ...botRoutes,
  ...broadcastRoutes,
  ...templateRoutes,
  ...blockRoutes,
  ...clientRoutes,
  ...chatRoutes,
  ...feedbackRoutes,
  ...integrationsRoutes,
  ...nlpRoutes,
  ...paymentRoutes,
  ...channelRoutes,
  ...docsRoutes,
  ...facebookRoutes,
  ...workplaceRoutes,
  ...teamRoutes,
  ...importRoutes,
  ...composerRoutes,
  ...ticketRoutes,
  ...groupRoutes,
  ...logRoutes,
  ...telegramRoutes,
  ...builderRoutes,
  ...instagramRoutes,
  ...linkRoutes,
  ...fileRoutes,
  ...alexaRoutes,
  ...voipRoutes,
  ...voiceRoutes,
  ...whatsAppRoutes,
  ...smsRoutes,
  ...rcsRoutes,
  ...generativeAiRoutes,
  ...mcpRoutes,
  ...viberRoutes,
  ...voiceCallRoutes
];

export default pluginRoutes;
